"use strict";
const isNaN = require('lodash/isNaN');
const numeral = require('numeral');
const getSymbolFromCurrency = require('currency-symbol-map');
const currencyCodes = require('currency-codes');
const { formatNumbers } = require('./formatNumbers');
const typeEnum = {
    International: 'International',
    EU: 'EU',
};
const usToEuCurrencyFormat = (value) => value.replace(/[,.]/g, (x) => (x === ',' ? '.' : ','));
const digitsInRange = (settings = {}) => {
    const digits = !isNaN(Number(settings?.digits)) ? settings?.digits : 2;
    if (digits < 0) {
        return 0;
    }
    if (digits > 10) {
        return 10;
    }
    return digits;
};
const formatCurrency = (number, settings, abbreviate) => {
    const type = settings?.format || typeEnum.International;
    const currencyCode = settings?.sign || 'USD';
    const symbol = getSymbolFromCurrency(currencyCode);
    const digits = digitsInRange(settings);
    let displayFormat = '0,0';
    if (digits > 0) {
        displayFormat += `.${'0'.repeat(digits)}`;
    }
    if (abbreviate) {
        displayFormat += 'a';
    }
    const formattedValue = symbol + numeral(number).format(displayFormat).toUpperCase();
    if (type === typeEnum.EU) {
        return usToEuCurrencyFormat(formattedValue);
    }
    return formattedValue;
};
const formatCurrencyByCurrencyCodes = (() => {
    const symbols = currencyCodes.codes()?.map((code) => {
        const symbol = getSymbolFromCurrency(code);
        return {
            value: code,
            label: symbol ? `${code} (${symbol})` : null,
        };
    }).filter((option) => option.label);
    return {
        symbols,
        options: [
            {
                value: typeEnum.International,
                label: 'International format (#,###.##)',
                formatedLabel: '#,###.##',
            },
            {
                value: typeEnum.EU,
                label: 'EU format (#.###,##)',
                formatedLabel: '#.###,##',
            },
        ],
        // eslint-disable-next-line default-param-last
        format: (number, type = typeEnum.International, digits = 2, currencyCode = 'USD', abbreviate, symbolSpacing) => {
            let letter = '';
            let num = number;
            if (abbreviate) {
                const displayFormat = digits > 0 ? `0.[${'0'.repeat(digits)}]a` : '0a';
                num = formatNumbers(number, displayFormat);
                letter = num.charAt(num.length - 1);
                if (isNaN(Number(letter))) {
                    num = num.substring(0, num.length - 1);
                }
                else {
                    letter = '';
                }
            }
            const locale = type === typeEnum.EU ? 'de-DE' : 'en-US';
            const symbol = getSymbolFromCurrency(currencyCode);
            const maximumFractionDigits = Math.max(0, Math.min(digits, 10));
            const formattedValue = Number(num).toLocaleString(locale, {
                maximumFractionDigits,
                minimumFractionDigits: maximumFractionDigits,
            });
            return `${symbolSpacing ? `${symbol} ` : symbol}${formattedValue}${letter}`;
        },
        getSign: getSymbolFromCurrency,
    };
})();
module.exports = {
    formatCurrency,
    formatCurrencyByCurrencyCodes,
};
//# sourceMappingURL=formatCurrency.js.map